import { render, staticRenderFns } from "./HelpCategoryArticles.vue?vue&type=template&id=3b316754&scoped=true&"
import script from "./HelpCategoryArticles.vue?vue&type=script&lang=js&"
export * from "./HelpCategoryArticles.vue?vue&type=script&lang=js&"
import style0 from "./HelpCategoryArticles.vue?vue&type=style&index=0&id=3b316754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b316754",
  null
  
)

export default component.exports